"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CODE_BLOCK_REGEX = exports.CODE_BLOCK_REGEX = /^```([\w-]+)?\s*$/;


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-markdown-plugin/lib/constants.js
// module id = 87
// module chunks = 0